import React from 'react';
import { Router, Route } from 'dva/router';
import { LocaleProvider } from 'antd';
import ja_JP from 'antd/lib/locale-provider/ja_JP';
import NewsPage from '../components/NewsPage';

function RouterConfig(props) {
  return (
    <LocaleProvider locale={ja_JP}>
      <Router history={props.history}>
        {/* <Route path="/" component={NewsPage} /> */}
        <Route path="/" render={() => <NewsPage appKey={props.app.appkey} />} />
      </Router>
    </LocaleProvider>
  );
}

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/news/config/router.js